import { Button, Col, Form, InputNumber, Modal, Row, Select, Spin } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import Title from 'antd/es/typography/Title';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getOnlyPersonInOrg as getEmployees, getSelectBoxRequiredAcceptProcess, getSelectBoxFunctionsProcess } from 'app/entities/common/common.reducer';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { createAdjustmentConfigure, createEntity, getAdjustmentConfigure, getApproveConfigure, getEntity, getTypeSelectboxApprovalLevel, reset, updateEntity } from '../approval-level.reducer';
import { FuncTypes } from 'app/shared/model/enum/func-type.enum';
import PlanPeriod from 'app/entities/plan-period/view/plan-period';

type ApprovalLevelForm = {
  isOpen: boolean,
  onClose: (isReload?: boolean) => void
  idItemSelected?: string
  selectedPlanPeriod?: any
}

export const ApprovalLevelUpdate = ({ isOpen, onClose, idItemSelected, selectedPlanPeriod }: ApprovalLevelForm) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const isNew = idItemSelected === undefined;

  const approvalLevelEntity = useAppSelector(state => state.approvalLevel.entity);
  const updating = useAppSelector(state => state.approvalLevel.updating);
  const viewing = useAppSelector(state => state.approvalLevel.viewing);
  const updateSuccess = useAppSelector(state => state.approvalLevel.updateSuccess);
  const filters = useAppSelector(state => state.filters.approvalLevel);
  const employeeList = useAppSelector(state => state.common.personPositions);
  const functions = useAppSelector(state => state.common.functionsProcess);
  const requiredAccepts = useAppSelector(state => state.common.requiredAccept);
  const loadingCreateAdjustmentConfigure = useAppSelector(state => state.approvalLevel.loadingCreateAdjustmentConfigure);

  // init state
  const [funcType, setFuncType] = useState(null);

  // watch data for changes
  const performersValue = Form.useWatch('performers', form);

  const handleClose = () => {
    form.resetFields();
    onClose(updateSuccess)
    // dispatch(reset());
  };

  useEffect(() => {
    if (isOpen) {
      innitData();
    }
  }, [isOpen]);

  useEffect(() => {
    if (updateSuccess) {
      dispatch(reset());
      handleClose();
    }
  }, [updateSuccess]);

  useEffect(() => {
    if (loadingCreateAdjustmentConfigure) {
      // dispatch(reset());
      handleClose();
    }
  }, [loadingCreateAdjustmentConfigure])

  useEffect(() => {
    if (approvalLevelEntity && !isNew) {
      form.setFieldsValue({
        ...approvalLevelEntity,
        startDate: dayjs(approvalLevelEntity.startDate),
        endDate: dayjs(approvalLevelEntity.endDate),
        function: approvalLevelEntity?.functionId,
        rule: approvalLevelEntity?.workflowRule
      });
    }
  }, [approvalLevelEntity]);

  const innitData = () => {
    dispatch(getSelectBoxRequiredAcceptProcess())
    dispatch(getSelectBoxFunctionsProcess(2))
    dispatch(getEmployees());
    dispatch(getTypeSelectboxApprovalLevel());
    // get detail
    if (isNew) {
      form.resetFields();
    } else {
      dispatch(getEntity(idItemSelected));
    }
  };

  const handleSubmit = values => {
    const entity = {
      ...approvalLevelEntity,
      ...values,
      ownerId: filters?.accountableId,
      planPeriodId: filters?.planPeriodId,
    };

    if (isNew) {
      if (selectedPlanPeriod === 3) {
        dispatch(createAdjustmentConfigure(entity)).then(() => {
          dispatch(getAdjustmentConfigure({ ownerid: filters?.accountableId, planPeriodId: filters?.planPeriodId }));
        })

      } else {
        dispatch(createEntity(entity)).then(() => {
          dispatch(getApproveConfigure({ ownerid: filters?.accountableId, planPeriodId: filters?.planPeriodId }));
        })
      }
    } else {
      dispatch(updateEntity(entity)).then(() => {
        if (selectedPlanPeriod === 3) {
          dispatch(getAdjustmentConfigure({ ownerid: filters?.accountableId, planPeriodId: filters?.planPeriodId }));
        } else {
          dispatch(getApproveConfigure({ ownerid: filters?.accountableId, planPeriodId: filters?.planPeriodId }));
        }
      })
    }
  };

  const handleChangeFuncs = (value, options) => {
    setFuncType(options.key)
  }

  return (
    <Modal open={isOpen} footer={null} maskClosable={false} onCancel={handleClose} width={1300} className="form">
      <Spin spinning={viewing || updating || loadingCreateAdjustmentConfigure} delay={300}>
        <Form size="large" form={form} onFinish={handleSubmit} layout="vertical">
          <Title level={3}>{`${idItemSelected ? 'Cập nhật thông tin' : 'Thêm mới'} cấp phê duyệt`}</Title>
          <Row>
            <Col md={11}>
              <Form.Item label="Thứ tự phê duyệt" name={'order'} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                <InputNumber className="w-100" size="large" placeholder="Thứ tự" />
              </Form.Item>
            </Col>
            <Col md={1} />
            <Col md={12}>
              <Form.Item label="Chức năng" name={'function'} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                <Select className="w-100" size="large" placeholder="Chức năng" onChange={handleChangeFuncs} filterOption={filterOption} options={functions.map(x => ({
                  ...x,
                  label: x.name,
                  value: x.id,
                }))} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24} span={2}>
              <Form.Item label="Tên cấp phê duyệt" name={'name'} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                <TextArea className="w-100" size="large" placeholder="Tên cấp phê duyệt" rows={1} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col md={24}>
              <Form.Item label="Người thực hiện" name={'performers'} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                <Select className="w-100" size="large" mode='multiple' placeholder="Người thực hiện" filterOption={filterOption} options={employeeList.map(x => {
                  return {
                    label: x.name,
                    value: x.id,
                  };
                })} />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            {(performersValue && performersValue.length > 1 && funcType !== FuncTypes.Appraisal) &&
              <>
                <Col md={11}>
                  <Form.Item label="Yêu cầu số tán thành để chuyển sang cấp phê duyệt tiếp theo" name={'rule'} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                    <Select className="w-100" size="large" placeholder="Số yêu cầu tán thành" filterOption={filterOption} options={requiredAccepts} />
                  </Form.Item>
                </Col>
                <Col md={1} />
              </>
            }
            <Col md={12}>
              <Form.Item label="Giới hạn thời gian thực hiện phê duyệt (ngày làm việc)" name={'workingDay'} rules={[{ required: true, message: "Vui lòng nhập" }]}>
                <InputNumber className="w-100" placeholder="Giới hạn thời gian" size="large" />
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            <Row className="action mt-3" justify="end">
              <Col>
                <Button
                  className="secondary"
                  onClick={() => {
                    handleClose();
                  }}
                >
                  Hủy
                </Button>
              </Col>
              <Col>
                <Button className="primary" htmlType="submit" disabled={updating}>
                  Lưu
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>
  );
};

export default ApprovalLevelUpdate;
